module.exports = __webpack_public_path__ + "media/images/gallery-image2-2cfab2a56d545fde44ffbd71bdd9577a.webp";